module.exports = __webpack_public_path__ + "img/qrcode_colder1.41a4a27e.png";